import { type FC } from 'react';
import styled from 'styled-components';

import { useOrganizationName } from '@/api/organizations/hooks/useOrganizationName';
import { useOrganizationsQuery } from '@/api/organizations/organizationsApi';
import { useOrganizationCmId } from '@/api/userSettings/hooks/useOrganizationCmId';
import { appConfig } from '@/constants/config';
import { prettifyOrganizationName } from '@/util/prettifyOrganizationName';

export const OrganizationNameBanner: FC = () => {
  const organizationCmId = useOrganizationCmId();
  const { organizationName } = useOrganizationName(organizationCmId);
  const organizationsQuery = useOrganizationsQuery();

  if (!organizationsQuery.data || organizationsQuery.data.length === 1) {
    // Don't show the banner if the user has only one organization.
    return null;
  }

  return (
    <Banner>
      <Center data-test="organization-name-banner">
        <DivWithPadding className="font-body-demibold">
          {prettifyOrganizationName(organizationName)}
        </DivWithPadding>
      </Center>
    </Banner>
  );
};

const Banner = styled.div`
  background-color: var(--p-color-surface-1);
  padding: 4px 0;
  margin-bottom: 12px;
`;

const Center = styled.div`
  max-width: ${appConfig.maxPageWidth};
  margin: 0 auto;
`;

const DivWithPadding = styled.div`
  padding: 0 24px;
`;
